import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9f405fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-select" }
const _hoisted_2 = {
  key: 0,
  class: "tab-select-box"
}
const _hoisted_3 = { class: "tab-select-left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "特色服务", -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "tab-select-right" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "my-coll-mark"
}
const _hoisted_12 = { class: "new" }
const _hoisted_13 = { class: "hot" }
const _hoisted_14 = {
  key: 1,
  class: "tab-select-box tab-select-flex"
}
const _hoisted_15 = {
  key: 0,
  class: "tab-select-flex1"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: `/marketCentre/specialPromotion?id=8&parentId=11` }, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "优惠促销")
], -1))
const _hoisted_17 = ["href"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, "惠", -1))
const _hoisted_19 = {
  key: 1,
  class: "tab-select-flex2"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: `/marketCentre/specialPromotion?id=8&parentId=11`,
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "title" }, "活动推荐")
], -1))
const _hoisted_21 = ["href"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "tab-select-flex3" }
const _hoisted_24 = ["href"]
const _hoisted_25 = {
  key: 2,
  class: "tab-select-box"
}
const _hoisted_26 = { class: "tab-select-flex4" }
const _hoisted_27 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.type != 8 && _ctx.type != 9)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.hotList.length !== 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                  _hoisted_5,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotList, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.id
                    }, [
                      _createVNode(_component_svg_icon, {
                        "icon-name": "star",
                        style: {"color":"blue"}
                      }),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: `${item.route}?id=${_ctx.items.id}&parentId=${item.id}`,
                          target: "_blank"
                        }, _toDisplayString(item.channel_name), 9, _hoisted_6)
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.child, (item) => {
              return (_openBlock(), _createElementBlock("ul", {
                key: item.id
              }, [
                _createElementVNode("p", _hoisted_8, [
                  _createElementVNode("a", {
                    href: `${item.route}?id=${_ctx.items.id}&parentId=${item.id}`,
                    target: "_blank"
                  }, _toDisplayString(item.channel_name), 9, _hoisted_9)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.child, (k) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: k.id
                  }, [
                    _createElementVNode("a", {
                      href: `${k.route}?id=${_ctx.items.id}&parentId=${item.id}&childId=${k.id}`,
                      target: "_blank"
                    }, _toDisplayString(k.channel_name), 9, _hoisted_10),
                    (k.is_new || k.is_hot)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("i", _hoisted_12, "new", 512), [
                            [_vShow, k.is_new]
                          ]),
                          _withDirectives(_createElementVNode("i", _hoisted_13, "hot", 512), [
                            [_vShow, k.is_hot]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ]))
      : (_ctx.type == 8)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            (_ctx.cuxiaoList.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cuxiaoList, (item) => {
                      return (_openBlock(), _createElementBlock("a", {
                        href: `/marketCentre/specialPromotion?id=8&parentId=11&specialPromotionId=${item.id}`,
                        key: item.id
                      }, [
                        _createElementVNode("li", null, [
                          _hoisted_18,
                          _createElementVNode("p", null, _toDisplayString(item.detail_title), 1)
                        ])
                      ], 8, _hoisted_17))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.marketList.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: `/marketCentre/marketingActivityDetail?id=8&parentId=12&detailId=${_ctx.marketList[0].id}`,
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.marketList[0].img_text,
                        style: {"width":"140px","height":"160px"}
                      }, null, 8, _hoisted_22)
                    ], 8, _hoisted_21)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.child, (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    href: `${item.route}?id=${_ctx.items.id}&parentId=${item.id}`,
                    target: "_blank",
                    key: item.id
                  }, [
                    _createElementVNode("li", null, _toDisplayString(item.channel_name), 1)
                  ], 8, _hoisted_24))
                }), 128))
              ])
            ])
          ]))
        : (_ctx.type == 9)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.child, (item) => {
                    return (_openBlock(), _createElementBlock("a", {
                      href: `${item.route}?id=${_ctx.items.id}&parentId=${item.id}`,
                      target: "_blank",
                      key: item.id
                    }, [
                      _createElementVNode("li", null, _toDisplayString(item.channel_name), 1)
                    ], 8, _hoisted_27))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}